module.exports = __webpack_public_path__ + "img/welcome.59e02b0d.jpg";